import { Navigate, useLocation } from "react-router-dom";
import { isAdmin } from "../../../helpers/role";

function AdminGuard(props: { children: any }) {
  const location = useLocation();
  const auth = localStorage.getItem("auth");
  if (!(auth && isAdmin(JSON.parse(auth).role))) {
    return <Navigate to="/login" replace state={{ redirectTo: location }} />;
  }

  return props.children;
}

export default AdminGuard;
